import {
  Conversation,
  PWMessage,
  ConversationViewTracking,
} from "custom-models";

import {
  CONVERSATION_FETCH_SUCCESS,
  CONVERSATION_CREATE_MESSAGE_SUCCESS,
  CONVERSATION_MESSAGE_RECIEVED,
} from "./constants";

export type ConversationsState = {
  [key: string]: { [key: number]: Conversation };
};

export const initialState: ConversationsState = {};

const reducer = (
  state: ConversationsState = initialState,
  action: {
    type: string;
    payload: any;
    timestamp: number;
    requestKey: string;
    args: any;
  }
): ConversationsState => {
  const response = action.payload?.response;
  const args = action.args;
  if (!response || !args) return state;

  switch (action.type) {
    case CONVERSATION_FETCH_SUCCESS:
      return {
        ...state,
        [args.topicType]: {
          ...(state[args.topicType] || {}),
          [args.topicId]: {
            ...(state[args.topicType]?.[args.topicId] || {}),
            id: response.results[0].id,
            object_id: args.topicId,
            content_type__model: args.topicType,
            messages: response.results[0].messages.reduce(
              (obj: { [key: number]: PWMessage }, m: PWMessage) =>
                !m ? obj : { ...obj, [m.id]: m },
              state[args.topicType]?.[args.topicId]?.messages || {}
            ),
            // notifications: response.results[0].notifications.reduce(
            //   (
            //     obj: { [key: string]: PWNotification },
            //     m: PWNotification
            //   ) => (!m ? obj : { ...obj, [m.uuid]: m }),
            //   state[args.topicType]?.[args.topicId]?.notifications ||
            //     {}
            // ),
            notifications: {},
            tracked_views: response.results[0].tracked_views.reduce(
              (
                obj: { [key: number]: ConversationViewTracking },
                m: ConversationViewTracking
              ) => (!m ? obj : { ...obj, [m.user_id]: m }),
              state[args.topicType]?.[args.topicId]?.tracked_views || {}
            ),
          },
        },
      };
    case CONVERSATION_CREATE_MESSAGE_SUCCESS:
      // Can only reduce new messages for conversations that have already been loaded
      if (!state[args.topicType]?.[args.topicId]) return state;

      return {
        ...state,
        [args.topicType]: {
          ...state[args.topicType],
          [args.topicId]: {
            ...state[args.topicType][args.topicId],
            messages: {
              ...state[args.topicType][args.topicId].messages,
              [response.id]: response,
            },
          },
        },
      };
    case CONVERSATION_MESSAGE_RECIEVED:
      // Can only reduce new messages for conversations that have already been loaded
      if (!state[args.topicType]?.[args.topicId]) return state;

      return {
        ...state,
        [args.topicType]: {
          ...state[args.topicType],
          [args.topicId]: {
            ...state[args.topicType][args.topicId],
            messages: {
              ...state[args.topicType][args.topicId].messages,
              [response.id]: response,
            },
          },
        },
      };
  }

  return state;
};

export default reducer;
